/**
 * Solución simple: Recargar página al hacer clic en imagen
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    
    const variantJson = document.querySelector('[data-variant-json]');
    
    if (!variantJson) return;

    let variants = [];
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (e) {
      return;
    }

    // Escuchar clics en imágenes SOLO de la galería (izquierda), NO del lightbox (derecha)
    document.addEventListener('click', function(e) {
      if (e.target.tagName === 'IMG') {
        
        // EXCLUIR lightbox/zoom (componente derecha) - NO debe recargar
        if (e.target.closest('.pswp') || 
            e.target.closest('.lightbox-image') ||
            e.target.classList.contains('lightbox-image')) {
          return; // Skip - mantener comportamiento normal del lightbox
        }
        
        // INCLUIR solo galería/thumbnails (componente izquierda) - SÍ debe recargar
        if (!e.target.closest('.product__media-container') && 
            !e.target.closest('[data-product-thumbnail]')) {
          return; // Skip - no es parte de la galería
        }
        
        const imgSrc = e.target.src;
        const imgFileName = imgSrc.split('/').pop().split('?')[0];
        
        // Buscar variante que tenga esta imagen
        const matchingVariant = variants.find(variant => {
          if (variant.featured_image && variant.featured_image.src) {
            const variantFileName = variant.featured_image.src.split('/').pop().split('?')[0];
            return variantFileName === imgFileName;
          }
          return false;
        });
        
        if (matchingVariant) {
          // Recargar página con variante correcta
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', matchingVariant.id);
          window.location.href = currentUrl.toString();
        }
      }
    });

  });

})();
